import firmaResponsableCPE from '../../../assets/image/firmaResponsableCPE.png';
import firmaResponsableTribunal from '../../../assets/image/firmaResponsableTribunal.png';
import { FacsimileOrganismoKey } from '../consts/organismoFacsimileSignature';

// La firma del preventor puede llegar precargada como una URL presignada de S3 (ver
// useEjecutionVisits), en vez del base64 que espera el backend al guardar/ejecutar la visita
// (igual que la firma dibujada a mano). Estas dos utilidades detectan ese caso y convierten
// la URL a base64 sin el prefijo "data:", descargando la imagen y leyendola con FileReader.
export const isSignatureUrl = (value?: string | null): boolean =>
    Boolean(value && /^https?:\/\//.test(value));

export const signatureUrlToBase64 = (url: string): Promise<string> =>
    fetch(url)
        .then((response) => response.blob())
        .then(
            (blob) =>
                new Promise<string>((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () =>
                        resolve((reader.result as string).replace(/^data:.*;base64,/, ''));
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                })
        );

export const RESPONSABLE_FACSIMILE_IMAGES: Record<FacsimileOrganismoKey, string> = {
    cpe: firmaResponsableCPE,
    tribunal: firmaResponsableTribunal
};

const base64PromiseByKey: Partial<Record<FacsimileOrganismoKey, Promise<string>>> = {};

const loadBase64 = (key: FacsimileOrganismoKey): Promise<string> => {
    if (!base64PromiseByKey[key]) {
        base64PromiseByKey[key] = fetch(RESPONSABLE_FACSIMILE_IMAGES[key])
            .then((response) => response.blob())
            .then(
                (blob) =>
                    new Promise<string>((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () =>
                            resolve((reader.result as string).replace(/^data:.*;base64,/, ''));
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    })
            );
    }

    return base64PromiseByKey[key] as Promise<string>;
};

export const buildResponsableFacsimileImage = (key: FacsimileOrganismoKey): Promise<string> =>
    loadBase64(key);
